import React from 'react';

interface IProps {
  content: string;
}

const StaticText: React.FC<IProps> = ({ content }) => (
  <span style={{ whiteSpace: 'pre-line' }}>{content}</span>
);

export default StaticText;
